define('datakit/lib/abstract.has.one.relationship.type',['require','exports','module','backbone','./relationship.type'],function(require, exports, module) {
  var Backbone         = require('backbone');
  var RelationshipType = require('./relationship.type');


  var AbstractHasOneRelationshipType = RelationshipType.extend({
    supportedResourceClass: Backbone.Model,
    canFetchResource: function() {
      return !!this.foreignModel.id;
    },
    staleOnForeignModelEvent: function() {
      return 'change:' + this.foreignModel.idAttribute;
    }
  });

  module.exports = AbstractHasOneRelationshipType;
});
